import React, {useEffect} from 'react';
import {motion} from 'framer-motion';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-24 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 20}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          className="bg-white p-10 md:p-16 rounded-[2rem] shadow-sm border border-slate-200"
        >
          <h1 className="text-5xl font-bold text-slate-900 mb-4 font-serif">Terms of Service</h1>
          <p className="text-base text-slate-500 mb-10 uppercase tracking-widest font-bold">Last Updated: January 2025</p>
          <div className="space-y-8 text-slate-700 font-light leading-relaxed text-lg md:text-xl">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">1. Acceptance of Terms</h2>
              <p>
                By accessing <a href="https://joinmymd.com" className="text-amber-700 underline">joinmymd.com</a> and participating in our programs, you accept and agree to be bound by the terms and provisions of this agreement. These terms apply to all visitors, users, and clients of MyMD Weight Loss.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">2. Independent Clinical Entity</h2>
              <p>
                <strong className="text-slate-900 font-semibold">JoinMyMD / MyMD Weight Loss</strong> is a wellness coaching and administrative service provider. We do not practice medicine, employ physicians, or direct clinical care. Medical evaluations and any prescriptions are conducted exclusively by independent, board-certified healthcare professionals licensed in your state. All clinical decisions are made solely by your treating provider.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">3. Health & Fitness Disclaimer</h2>
              <p>
                <strong className="text-slate-900 font-semibold">Not Medical Advice:</strong> The content on joinmymd.com and our 6-Week Challenge protocols are for informational and coaching purposes only. They are not intended to substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider before starting any diet or exercise program.
              </p>
              <p className="mt-4">
                Individual results vary based on adherence, starting point, and medical history. Results are not guaranteed and are dependent on individual factors.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">4. User Responsibilities</h2>
              <p className="mb-4">As a participant in our program, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate, current, and complete information during your application.</li>
                <li>Follow the prescribed 6-Week Protocol as directed by your assigned coach.</li>
                <li>Participate in all required daily accountability check-ins.</li>
                <li>Communicate honestly about your progress and any challenges you encounter.</li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">5. Billing & Refund Policy</h2>
              <p>
                By enrolling in the 6-Week Challenge, you agree to pay all applicable program fees. Our full refund and cancellation terms are detailed in our <a href="/refund-policy" className="text-amber-700 underline">Refund Policy</a>, which is incorporated into these Terms by reference.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">6. Limitation of Liability</h2>
              <p>
                In no event shall MyMD Weight Loss, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your access to or use of, or inability to access or use, the service.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">7. Contact</h2>
              <ul className="list-none space-y-1">
                <li><strong className="text-slate-900 font-semibold">MyMD Weight Loss</strong></li>
                <li>7250 Pierson Dr, Mobile, AL 36619</li>
                <li><a href="tel:2512352120" className="text-amber-700 underline">251-235-2120</a></li>
                <li><a href="mailto:support@joinmymd.com" className="text-amber-700 underline">support@joinmymd.com</a></li>
                <li><a href="https://joinmymd.com" className="text-amber-700 underline">joinmymd.com</a></li>
              </ul>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;